import { AppModule } from '@/store/modules/app';

// Short links to one job ad, profile or course: /jobs/123, /workers/123 (or /cv/123),
// /courses/123. The router turns them into the section page with the panel open
// (?jobViewId / ?workerViewId / ?courseViewId), so they work on every site.

export type ShareType = 'jobs' | 'workers' | 'courses';

export const shareLink = (type: ShareType, id: number | string | null | undefined): string => {
  const link = `${window.location.origin}/${type}/${id}`;
  // Keep the portal language, so the receiver sees the same language
  return AppModule.language ? `${link}?lang=${AppModule.language}` : link;
};

// No string id yet — plain text until it is added to the translations
const COPY_LINK_LABELS: Record<string, string> = {
  de: 'Link kopieren',
  en: 'Copy link',
};

export const copyLinkLabel = (): string => COPY_LINK_LABELS[AppModule.language] || COPY_LINK_LABELS.en;

// Clipboard API, with the old copy command where it is not available (http, old browsers)
export const copyText = async(value: string): Promise<void> => {
  try {
    await navigator.clipboard.writeText(value);
  } catch {
    const field = document.createElement('textarea');
    field.value = value;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.append(field);
    field.select();
    document.execCommand('copy');
    field.remove();
  }
};
